import { __awaiter } from '../../_virtual/_tslib.js';
import API from '../const.js';
import { QueryNames } from './queryNames.js';
import { getAuthHeader } from '../utils/getAuthHeader.js';
import { handleMutateResponse } from '../utils/handleMutateResponse.js';
import useVahakHttpClient from '../../hooks/useVahakHttpClient.js';
import { useVahakMutationQuery, useVahakQuery } from '../../hooks/useVahakQueryClient.js';

function useSubmitBulkLoads() {
    // const queryClient = useQueryClient();
    const { POST } = useVahakHttpClient();
    const submitBulkUploadRequest = (payload) => {
        return POST(`${API.POST_BULK_LOAD}`, payload);
    };
    return useVahakMutationQuery(QueryNames.bulkUpload.load, submitBulkUploadRequest);
}
function handleBulkUploadResponse(mutateFn, bulkLoadPostRequest) {
    return __awaiter(this, void 0, void 0, function* () {
        return handleMutateResponse(mutateFn, bulkLoadPostRequest);
    });
}
const getBulkProgress = (requestId, queryClient) => __awaiter(void 0, void 0, void 0, function* () {
    // Falsy requestId
    if (!requestId)
        throw new Error("Service Unavailable");
    try {
        const res = yield fetch(`${API.BULK_LOAD_POSTING_STATUS}req_id=${requestId}`, {
            method: "GET",
            headers: Object.assign({ Accept: "application/json", "Content-Type": "application/json", Key: process.env.NEXT_PUBLC_REACT_APP_KEY || "" }, getAuthHeader())
        });
        if (res.ok) {
            const resData = yield res.json();
            if (resData.data.company_id === 0) {
                // Wrong request id passed
                throw new Error("Service Unavailable");
            }
            const currentProcessedItemCount = resData.data.overall_progress.done;
            const totalItemCount = resData.data.total_items;
            const successfulLoadPostingCount = resData.data.records.filter((record) => record.status_code < 300).length;
            const failedRecords = resData.data.records.filter((record) => record.status_code >= 400);
            return {
                progress: Math.round((currentProcessedItemCount / totalItemCount) * 100) || 0,
                currentProcessedItemCount,
                totalItemCount,
                failedRecords,
                successfulLoadPostingCount
            };
        }
        else {
            // Error from server
            if (res.status === 401) {
                queryClient.invalidateQueries(QueryNames.validateToken);
            }
            throw new Error("Service Unavailable");
        }
    }
    catch (err) {
        // Network Error
        throw new Error("Service Unavailable");
    }
});
const useGetBulkLoadPostingStatus = ({ requestId }, options) => {
    const { GET } = useVahakHttpClient();
    const getBulkProgress = () => {
        return GET(`${API.BULK_LOAD_POSTING_STATUS}req_id=${requestId}`);
    };
    return useVahakQuery([QueryNames.bulkUpload.bulkLoadStatus, requestId], getBulkProgress, Object.assign(Object.assign({}, options), { select: (res) => {
            const { data } = res;
            const currentProcessedItemCount = data.overall_progress.done;
            const totalItemCount = data.total_items;
            const successfulLoadPostingCount = data.records.filter((record) => record.status_code < 300).length;
            const failedRecords = data.records.filter((record) => record.status_code >= 400);
            return {
                progress: Math.round((currentProcessedItemCount / totalItemCount) * 100) || 0,
                currentProcessedItemCount,
                totalItemCount,
                failedRecords,
                successfulLoadPostingCount
            };
        } }));
};

export { getBulkProgress, handleBulkUploadResponse, useGetBulkLoadPostingStatus, useSubmitBulkLoads };
//# sourceMappingURL=useBulkUploadService.js.map
